<template>
    <div>
        <div class="row mt-3">
            <div class="col-md-8 col-12">
                <div class="form-group row" v-for="(account, index) in sitePayment" :key="index">
                    <label class="col-sm-4 col-form-label bold"
                        >Thông tin tài khoản ngân hàng số: {{ index + 1 }}</label
                    >
                    <div class="col-sm">
                        <div class="card card-table">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-6">
                                        <h6>
                                            Ngân hàng: <span class="bold">{{ account.name }}</span>
                                        </h6>
                                        <h6>
                                            Chủ TK: <span class="bold">{{ account.account_name }}</span>
                                        </h6>
                                        <h6>
                                            STK: <span class="bold">{{ account.account_number }}</span>
                                        </h6>
                                        <h6>
                                            Chi nhánh: <span class="bold">{{ account.branch }}</span>
                                        </h6>
                                        <button
                                            @click="setEditBank(index)"
                                            type="button"
                                            class="btn btn-primary btn-xs mr-1 px-3"
                                            data-toggle="modal"
                                            href="#modal-bank-account"
                                        >
                                            Sửa
                                        </button>
                                        <button
                                            @click="deleteBankAccount(index)"
                                            type="button"
                                            class="btn btn-danger btn-xs mr-1 px-3"
                                        >
                                            Xóa
                                        </button>
                                    </div>
                                    <div v-if="account.qr_code" class="col-6 text-right">
                                        <Qrcode :value="account.qr_code" :size="125" level="H" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <label class="col-sm-4 col-form-label font-bold"></label>
                    <div class="col-sm-8">
                        <button
                            data-toggle="modal"
                            href="#modal-bank-account"
                            class="btn mt-3 form-control bold btn-dark-blue"
                            type="submit"
                        >
                            Thêm tài khoản ngân hàng
                        </button>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-4 col-12">
                        <h6 class="bold">Cài đặt nội dung chuyển khoản:</h6>
                    </div>
                    <div class="col">
                        <input
                            type="text"
                            placeholder="Cài đặt nội dung chuyển khoản"
                            class="form-control input-light"
                            v-model="siteUpdate.config.payment_syntax"
                        />
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-4 col-12">
                        <h6 class="bold">Cài đặt hướng dẫn hiển thị cho khách hàng:</h6>
                    </div>
                    <div class="col">
                        <textarea
                            v-model="siteUpdate.config.payment_note"
                            class="form-control textarea-light"
                            rows="5"
                            placeholder="Nhập nội dung hướng dẫn hiển thị cho khách hàng"
                        ></textarea>
                        <div class="row">
                            <div class="col-md-6">
                                <button
                                    @click="updateSiteInfo(true)"
                                    class="btn-block btn-lg btn bold btn-red form-control mt-3"
                                    type="submit"
                                >
                                    Khôi phục cài đặt gốc
                                </button>
                            </div>
                            <div class="col-md-6">
                                <button
                                    @click="updateSiteInfo()"
                                    class="btn form-control btn-lg bold btn-dark-blue form-control mt-3"
                                    type="submit"
                                >
                                    Lưu thông tin
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 col-12">
                <div class="card card-red">
                    <div class="card-body">
                        <div class="">
                            <h6>
                                <i class="fa fa-info mr-1"></i>
                                Bạn có thể cài đặt thông tin tài khoản ngân hàng, hướng dẫn nạp tiền, cú pháp của trang
                                tại đây.
                            </h6>
                            <h6>
                                Bạn có thể nhập thêm cú pháp: {username} để hiển thị username người dùng. Ví dụ: NAPTIEN
                                {username}
                            </h6>
                            <div class="bold">
                                Chọn khôi phục cài đặt gốc nếu bạn lưu thông tin thất bại!
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            id="modal-bank-account"
            class="modal fade"
            tabindex="-1"
            role="dialog"
            aria-labelledby="bankAccount"
            aria-hidden="true"
            style="display: none;"
        >
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Thêm Tài Khoản Ngân Hàng</h4>
                    </div>
                    <form @submit.stop.prevent="updateBankAccount">
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Ngân Hàng:</label>
                                <input type="text" v-model="bank.name" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Tên Chủ Tài Khoản:</label>
                                <input type="text" v-model="bank.account_name" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Số Tài Khoản:</label>
                                <input type="text" min="1" v-model="bank.account_number" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Chi Nhánh:</label>
                                <input type="text" v-model="bank.branch" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label>Link QR Code :</label>
                                <input type="text" v-model="bank.qr_code" class="form-control" />
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default waves-effect" data-dismiss="modal">
                                Hủy bỏ
                            </button>
                            <button type="submit" :class="['btn btn-primary waves-effect waves-light']">
                                Cập Nhật
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Qrcode from "qrcode.vue"
import { updateSiteInfo } from "../../../api/admin"
import { catchError } from "../../../helpers"
export default {
    name: "site-payment",
    components: { Qrcode },
    props: {
        levelList: Array,
        site: Object
    },
    data() {
        return {
            siteUpdate: {},
            sitePayment: [],
            bank: {},
            bankEditId: null
        }
    },
    computed: {
        user() {
            return this.$store.state.user.user
        },
        tools() {
            return this.$store.state.tools.tools
        },
        isMobile() {
            return this.$store.state.app.isMobile
        },
        reload() {
            return this.$store.state.app.reload
        },
        currency() {
            return this.$store.state.site.site.currency || "Xu"
        }
    },
    watch: {
        site() {
            this.siteUpdate = Object.assign({}, this.site)
            this.sitePayment = JSON.parse(this.site.payment)
        }
    },
    created() {
        this.siteUpdate = Object.assign({}, this.site)
        this.sitePayment = JSON.parse(this.site.payment)
    },
    methods: {
        setEditBank: function(id) {
            this.bank = Object.assign({}, this.sitePayment[id])
            this.bankEditId = id
        },
        deleteBankAccount: async function(id) {
            this.sitePayment.splice(id, 1)
            this.siteUpdate.payment = JSON.stringify(this.sitePayment)
            this.updateSiteInfo()
        },
        updateBankAccount: async function() {
            if (this.bankEditId === null) {
                let paymentJSON = this.sitePayment ? this.sitePayment : []
                paymentJSON.push({
                    name: this.bank.name,
                    account_number: this.bank.account_number,
                    account_name: this.bank.account_name,
                    branch: this.bank.branch
                })
                let paymentText = JSON.stringify(paymentJSON)
                this.siteUpdate.payment = paymentText
            } else {
                let editData = {
                    name: this.bank.name,
                    account_number: this.bank.account_number,
                    account_name: this.bank.account_name,
                    branch: this.bank.branch
                }
                this.sitePayment.splice(this.bankEditId, 1, editData)
                this.bankEditId = null
                this.siteUpdate.payment = JSON.stringify(this.sitePayment)
            }
            this.updateSiteInfo()
        },
        updateSiteInfo: async function(reset = false) {
            let cancel = false
            if (reset) {
                await this.$swal({
                    title: "Xác nhận",
                    html:
                        "Sau khi khôi phục cài đặt bạn sẽ phải cài lại giao diện, nội dung chuyển khoản và Facebook hỗ trợ.</br></br>Bạn có chắc chắn muốn khôi phục cài đặt gốc?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Đồng Ý",
                    cancelButtonText: "Không",
                    reverseButtons: true
                }).then(result => {
                    if (result.value) {
                        this.siteUpdate.config = null
                    } else {
                        cancel = true
                    }
                })
            }
            if (cancel) {
                return
            }
            let data = await updateSiteInfo(this.siteUpdate)
            if (data.status === 200 && data.success) {
                let siteHost = document.location.host
                this.$swal("Thành Công", data.message, "success")
                // eslint-disable-next-line no-undef
                $("#modal-bank-account").modal("hide")
                await this.$store.dispatch("GET_SITE", siteHost)
            } else this.$swal("Lỗi", catchError(data), "error")
        }
    }
}
</script>
